import Axios from "axios";

export const SelectArticle = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/ARTICLEs?coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "ARTICLE_SELECT", payload: response.data });
    });
  };
};

